/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import './ProgramCard.scss';
import { orderBy } from 'lodash';
import { FIRST_DAY, LAST_DAY, YEAR, streams } from '../../../constants';

const ProgramCard = ({
  id,
  speakers = [],
  tileRole,
  talk,
  color,
  onCardClick,
  selectedTalk,
  isLive,
  isConferenceDay
}) => {
  const history = useHistory();
  const cardRef = useRef(null);
  const talkExist = Object.entries(talk).length > 0;
  const orderedSpeakers = speakers.length > 0 ? orderBy(speakers, ['order'], 'desc') : [];

  const onTalkClick = (e, talkId) => {
    if (
      id &&
      history.location.pathname === '/program' &&
      (typeof e.target.className === 'string'
        ? e.target.className.includes('click-link')
        : false) &&
      tileRole !== 'CLOSED'
    ) {
      onCardClick(talkId);
    }
    if (
      id &&
      (typeof e.target.className === 'string'
        ? !e.target.className.includes('click-link')
        : false) &&
      tileRole !== 'CLOSED'
    ) {
      history.push(`/program/${talkId}`);
    }
  };

  useEffect(() => {
    if (
      history.location.pathname === '/program' &&
      selectedTalk &&
      selectedTalk === id &&
      cardRef.current
    ) {
      window.scrollTo(0, cardRef.current.offsetTop - 10);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={cardRef} id="program-card">
      <div
        className={`card ${
          Object.entries(talk).length === 0 || !id || tileRole === 'CLOSED' ? 'not-clickable' : ''
        } ${tileRole === 'CLOSED' ? 'closed' : ''}`}
        onClick={talkExist ? e => onTalkClick(e, id) : undefined}>
        <div className={`card-color-marker track-${color}-color`} />
        <div className="card-content">
          {talkExist ? (
            <>
              <p className="program-card-top-row">{talk.title || tileRole}</p>
              <div className="program-card-speakers">
                {orderedSpeakers.map(speaker => (
                  <div key={speaker.id || speaker.name} className="speakers">
                    <div>{speaker.name}</div>
                    <div className="speakers-company">
                      {speaker.company === '---'
                        ? speaker.country
                        : `${speaker.company} - ${speaker.country}`}
                    </div>
                  </div>
                ))}
                {isConferenceDay &&
                talk.track !== 'Interactive 3-hour Hands-on Lab' &&
                !talk.youtube &&
                talk.tileRole !== 'CLOSED' &&
                talk.isBreak !== true ? (
                  <span className="live">
                    {isLive ? (
                      <span className="icon-text green">
                        <span className="icon pulse">
                          <i className="fas fa-circle" />
                        </span>
                        <span className="bold-text">LIVE</span>
                      </span>
                    ) : null}
                    <span className="icon-text click-link">
                      <a
                        className="video-link"
                        href={streams[talk.trackInDay].live}
                        rel="noopener noreferrer"
                        target="_blank"
                        type="button">
                        <span className="icon click-link">
                          <i className="fab fa-youtube fa-lg" />
                        </span>
                        <span className="click-link">Stream</span>
                      </a>
                    </span>
                  </span>
                ) : null}
                {talk.youtube ? (
                  <span className="icon-text click-link">
                    <a
                      className="video-link"
                      href={talk.youtube}
                      rel="noopener noreferrer"
                      target="_blank">
                      <span className="icon click-link">
                        <i className="fab fa-youtube-square fa-2x" />
                      </span>
                      <span className="click-link">Recording</span>
                    </a>
                  </span>
                ) : null}
              </div>
              <div className="bottom-part">
                {history.location.pathname.includes('/speakers') ? (
                  <div>
                    <div className="date">
                      {talk.conferenceDay === 'day1'
                        ? `Oct ${FIRST_DAY}, ${YEAR}`
                        : `Oct ${LAST_DAY}, ${YEAR}`}
                    </div>
                    <div className="time">
                      {talk.startTime} - {talk.endTime}
                    </div>
                  </div>
                ) : null}
                {talk.room ? (
                  <div className="room">
                    <i className={`fa fa-map-marker-alt track-${color} room-icon`} />
                    {talk.room}
                  </div>
                ) : null}
              </div>
            </>
          ) : (
            <div>
              <p className="program-card-top-row">
                <span className="is-full-desktop">{tileRole}</span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ProgramCard.defaultProps = {
  color: '',
  id: '',
  onCardClick: () => {},
  selectedTalk: ''
};

ProgramCard.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  isConferenceDay: PropTypes.bool.isRequired,
  isLive: PropTypes.bool.isRequired,
  onCardClick: PropTypes.func,
  selectedTalk: PropTypes.string,
  speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
  talk: PropTypes.objectOf(PropTypes.any).isRequired,
  tileRole: PropTypes.string.isRequired
};

export default ProgramCard;
